











import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class HalfSelectedCheckbox extends Vue {
  @Prop()name!: string;
  @Prop()value!: boolean;
  @Prop()inputClass!: string;
  @Prop()disabled!: boolean;
  @Prop()halfSelected!: boolean;

  get getValue(){
    if(!this.value)
      return false;

    return this.value;
  }

  input(){
    if(this.disabled){
      return;
    }
    const returnVal = this.value;
    this.$emit('input',!returnVal);
  }
}
